import useQuotationHeader from '../../../../../hooks/sale/useQuotationHeader';

import QuotationHeaderFields from './QuotationHeaderFields';

const QuotationHeaderBar = () => {
  // =====================================================
  // 🔹 Header Logic
  // =====================================================
  const props = useQuotationHeader();

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        rounded-xl

        border border-stroke

        bg-white

        p-4

        shadow-sm

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <QuotationHeaderFields {...props} />
    </div>
  );
};

export default QuotationHeaderBar;
